import React from 'react';
import { useHistory } from 'react-router-dom';
import { Avatar } from '@mui/material';
import Chip from 'Components/Chip';
import { colors } from 'Constants/Colors';

const chipColors = [colors.GREEN, colors.RED, colors.PURPLE, colors.YELLOW, colors.BLUE, colors.PINK, colors.BROWN];
const colorCategory = {};

const useComponent = ({ categories, courses }) => {
  let counter = 0;
  categories.forEach(category => {
    if (counter === chipColors.length) counter = 0;
    colorCategory[category] = chipColors[counter];
    counter += 1;
  });
  const history = useHistory();

  const thereIsComponent = (data, index) => {
    if (index === 3) {
      return (
        <Chip
          style={{
            border: 'none',
            background: `${colorCategory[data[index]]}`,
            color: colors.WHITE,
          }}
        >
          {null}
          <h4>{data[index]}</h4>
        </Chip>
      );
    }
    if (index === 4) {
      return (
        <div style={{ display: 'flex' }}>
          <Chip>
            <Avatar alt={data[index]} src={data[courses.length - 3]} />
            <h4>{data[index]}</h4>
          </Chip>
        </div>
      );
    }
    return data[index];
  };

  const sendToCourseDetails = course => {
    history.push({
      pathname: '/cursos/detalles',
      state: {
        update: true,
        course,
        colorCategory: colorCategory[course[3]],
        isComingFrom: '/mis-cursos',
      },
    });
  };

  return {
    thereIsComponent,
    colorCategory,
    sendToCourseDetails,
  };
};

export default useComponent;
